<template>
  <div>
    <UiModal :open="status_show_popup" @close="status_show_popup = false" class="size-sm">

      <div class="px-4 pt-5 pb-4">

        <div>
          <h4 class="tac mb-4 pb-3">
            {{pad_title || lg('',{
              en: 'Share This NFT',
              zh: '分享我的NFT',
            })}}
          </h4>
        </div>

        <!-- intro: 1. use "<a>" tag. 2.use "a2a_..." class -->
        <div class="icon-box a2a_kit d-flex flex-wrap" :data-a2a-url="share_link" :data-a2a-title="share_title">
          <a class="a2a_button_twitter">
            <i class="fab fa-twitter"></i>
            <span 
              class="d-block small"
              >
              Twitter
            </span>
          </a>
          <a class="a2a_button_facebook">
            <i class="fab fa-facebook"></i>
            <span 
              class="d-block small"
              >
              Facebook
            </span>
          </a>
          <a class="a2a_button_telegram">
            <i class="fab fa-telegram"></i>
            <span 
              class="d-block small"
              >
              Telegram
            </span>
          </a>

          <!-- <a class="cp" @click="callWechatPopup()">
            <i class="fab fa-weixin"></i>
            <span 
              class="d-block small"
              >
              Wechat
            </span>
          </a> -->

          <a class="a2a_button_copy_link">
            <i class="fab fas fa-link"></i>
            <span 
              class="d-block small"
              >
              {{lg('copy_link')}}
            </span>
          </a>
        </div>

      </div>
    </UiModal>

  </div>
</template>
<script>
var a2a_config = a2a_config || {};
a2a_config.num_services = 10;
a2a_config.show_title = 1;
</script>

<script>
import bus from '@/bus.js'

export default {
  components: {},
  props: [
    'mark_ui_call',
  ],
  data () {
    return {
      share_link: '',
      share_title: "",

      pad_title: "",

      status_show_popup: false,
    };
  },
  watch: {
    mark_ui_call(val){
      let v = this
      v.calcParams()
      v.status_show_popup = true
      setTimeout(function(){
        v.initA2A()
      },200)
    },
  },


  methods: {

    callWechatPopup(){
      this.status_show_popup = false
      bus.headervue.status_show_qrcode_wechat = true
    },

    calcParams(){
      let v = this 

      let d = v.mark_ui_call

      v.share_link = d.share_link || `${window.location.origin}/assets/${d.nft_address}/${d.nft_id}?owner=${d.owner}`
      v.share_title = d.share_title || `Hey everyone, check this out. "${d.name}" #JuggerWORLD #JGNdefi  #BSC  #Collectible #NFT`

      v.pad_title = d.pad_title || ''
    },

    initA2A(){
      console.log('initA2A')
      if(!document.querySelector('#a2a_script')){
        let script = document.createElement('script')
        script.id = 'a2a_script'
        script.src = '/static/src/addtoany.js'
        document.body.appendChild(script)
      }else{
        if(window.a2a) window.a2a.init_all()
      }
    },
  },

  mounted() {
  },
}

</script>

<style lang="scss">
.a2a_kit{
  a{
    width: 50%;
    display: block;
    text-align: center;
    margin-bottom: 25px;

    i{
      display: block;
      font-size: 26px;
    }

    span{
      margin-top: 10px;
      line-height: 20px;
    }
  }
}
@media (max-width:789px) {
  .a2a_kit {
    a{
      margin-top: 15px;
      text-align: center;

      i{
        font-size: 20px;
      }
    }
  }
}
</style>
